import {
  FoodItemAPI,
  GetBillingsResponse,
  GetOrderDetailsResponse,
  GetOrdersResponse,
  OrderItemAPI
} from '@/ducks/orders/services/orders.api.types'
import {
  FoodItem,
  IBilling,
  IOrderDetails,
  OrderItem
} from '@/ducks/orders/slices/orders.slice'

export const mapOrderItem = (data: OrderItemAPI): OrderItem => ({
  status: data.status.key,
  user: {
    firstName: data.user.first_name,
    lastName: data.user.last_name,
    avatarUrl: data.user.avatar,
    userName: data.user.username
  },
  restaurantPayout: Number(data.restaurant_payout),
  payout: data.restaurant_payout,
  id: data.order_id,
  foodCount: data.food_count,
  timeOut: data.time_out,
  orderTime: data.order_time,
  estimatedPreparationTime: data.estimated_preparation_time,
  timeLeft: data.time_left,
  isReady: data.isReady,
  isReturned: data.returned,
  isAssigned: data.assigned,
  driver_name: '',
  remainingETA: 0,
  brand: data.brand ?? null,
  supportPhone: { code: data.support?.code, number: data.support?.number },
  ...({ child_details: data.child_details } || {}),
  autoAccepted: data.auto_accepted === true
})

export const mapGetOrdersResponse = (
  data: GetOrdersResponse
): { ordersCount: number; orders: OrderItem[] } => ({
  ordersCount: data.orders_count,
  orders: data.orders.map(mapOrderItem)
})

export const mapGetOrderDetailsResponse = (
  data: GetOrderDetailsResponse
): IOrderDetails => {
  return {
    user: {
      username: data.user.username,
      lastName: data.user.last_name,
      avatarUrl: data.user.avatar
    },
    isReady: data.isReady,
    orderId: data.order_id,
    foods: data.foods.map(
      (food: FoodItemAPI): FoodItem => ({
        isConfirmed: !!food.confirmed,
        name: food.name,
        id: food.id,
        price: food.price,
        slug: food.slug,
        quantity: food.quantity,
        instruction: food.instruction,
        barcode: food.barcode,
        total: food.total,
        mainCategory: food.main_category,
        subCategory: food.sub_category
      })
    ),
    status: {
      value: data.status.key
    },
    timeOut: data.time_out,
    orderTime: data.order_time,
    estimatedPreparationTime: data.estimated_preparation_time,
    timeLeft: data.time_left,
    isReturned: data.returned,
    isAssigned: data.assigned,
    isReturnedToStock: data.isReturnedToStock,
    driver_name: '',
    remainingETA: 0,
  }
}

export const mapBillingResponse = (data: GetBillingsResponse): IBilling => ({
  subtotal: data.billings.subtotal,
  discount: data.billings.discount,
  serviceCharge: data.billings.service_charge,
  taxAmount: data.billings.tax_amount,
  taxValue: data.billings.tax_value,
  commission: data.billings.commission,
  earnings: data.billings.earnings,
  paymentMethod: data.billings.paymentMethod
})
